import { DropDown } from "@etframework/ui.components";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { PropertyRow } from "../PropertyUpdateRowInput";
import { isNullOrUndefined } from "../../../utils/helpers";

export const SourceUpdateInput = forwardRef(
  (
    { change, field, settings, onRemove, getDataSource, value = null, id },
    ref
  ) => {
    const compRef = useRef(null);
    const [dataSource, setDataSource] = useState([]);
    const [dataFields, setDataFields] = useState({
      value: "value",
      text: "text",
    });

    const getDisplayValue = useCallback(
      (value) => {
        if (!value) return null;
        if (!dataSource) return null;

        return dataSource.find((data) => data[dataFields.value] === value)[
          dataFields.text
        ];
      },
      [dataSource, dataFields]
    );

    const getValue = () => {
      const value = compRef.current?.getValue();
      return {
        field: field,
        value: value,
        displayValue: getDisplayValue(value),
        hasValue: !!value,
        settings: settings,
      };
    };

    useImperativeHandle(ref, () => ({
      getValue,
      focus: () => compRef.current?.getComponentRef()?.focusIn(),
      applyValue: (properties) => {
        const value = compRef.current.getValue();
        if (!isNullOrUndefined(value)) properties[field] = value;
      },
    }));

    useEffect(() => {
      const _getData = async () => {
        const result = await getDataSource(field);
        if (result?.data) setDataSource(result?.data);
        if (result.fields) setDataFields(result?.fields);
      };
      _getData();
    }, []);

    return (
      <PropertyRow
        key={field}
        field={field}
        label={settings?.headerText}
        onRemove={onRemove}
        settings={settings}
      >
        <DropDown
          ref={compRef}
          className={"w-50"}
          id={id}
          fields={dataFields}
          dataSource={dataSource}
          value={value}
          change={change}
          allowFiltering
        />
      </PropertyRow>
    );
  }
);
